import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {addOrOverwrite} from "../../../../../store/api";
import Intervention from "../../../../../entity/emergency/Intervention";
import isNull from "../../../../../mixin/isNull";
import Client from "../../../../../entity/emergency/Client";
import QualityInspection from "../../../../../entity/emergency/QualityInspection";
import Order from "../../../../../entity/emergency/Order";
import OrderAddress from "../../../../../entity/emergency/OrderAddress";
import OrderItem from "../../../../../entity/emergency/OrderItem";
import RequestedDocument from "../../../../../entity/emergency/RequestedDocument";
import {useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import Quotation from "../../../../../entity/emergency/Quotation";

const QUOTATION_VALIDATION_DELAY = 10000;

export default function () {
    const {token} = useParams();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    /** @type Intervention */
    const intervention = useSelector(state => state.api?.emergency?.interventions?.[1]);
    const client = useSelector(state => state.api?.emergency?.clients?.[1]);
    const qualityInspection = useSelector(state => state.api?.emergency?.quality_inspections?.[1]);
    const order = useSelector(state => state.api?.emergency?.orders?.[150]);
    const quotation = useSelector(state => state.api?.emergency?.quotations?.[1]);
    const orderAddress = useSelector(state => state.api?.emergency?.order_addressess?.[1]);
    const orderItems = useSelector(state => state.api?.emergency?.order_items?.filter(oi => !isNull(oi)));
    const requestedDocuments = useSelector(state => state.api?.emergency?.requested_documents?.filter(oi => !isNull(oi)));

    useEffect(() => {
        if (isNull(qualityInspection) || isNull(intervention) || global?.step_initialized === true) return;

        global.step_initialized = true;

        handleStartTo(searchParams.get("startTo"));
    }, [qualityInspection?.getId(), intervention?.getId()]);

    const handleStartTo = startTo => {
        if (isNull(startTo) || startTo === "") return;

        if (startTo == QualityInspection.STEP_APPOINTMENT) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_currentStep", QualityInspection.STEP_APPOINTMENT);
        }

        if (startTo == QualityInspection.STEP_TRAVEL) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_currentStep", QualityInspection.STEP_TRAVEL);
        }

        if (startTo == QualityInspection.STEP_PICTURE_BEFORE) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_currentStep", QualityInspection.STEP_PICTURE_BEFORE);
        }

        if (startTo == `${QualityInspection.STEP_QUOTATION}.${QualityInspection.SUB_STEP_ALL_TO_VALIDATE}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_currentSubStep", QualityInspection.SUB_STEP_ALL_TO_VALIDATE);
            patchQualityInspection("_currentStep", QualityInspection.STEP_QUOTATION);

            setTimeout(() => {
                patchQualityInspection("_quotationValidate", true);
                patchQualityInspection("_currentSubStep", QualityInspection.SUB_STEP_ALL_VALIDATED);
            }, QUOTATION_VALIDATION_DELAY);
        }


        if (startTo == `${QualityInspection.STEP_QUOTATION}.${QualityInspection.SUB_STEP_ALL_VALIDATED}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_quotationValidate", true);
            patchQualityInspection("_currentSubStep", QualityInspection.SUB_STEP_ALL_VALIDATED);
            patchQualityInspection("_currentStep", QualityInspection.STEP_QUOTATION);
        }

        if (startTo == `${QualityInspection.STEP_CLIENT_SIGNATURE}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_quotationValidate", true);
            patchQualityInspection("_currentStep", QualityInspection.STEP_CLIENT_SIGNATURE);
        }

        if (startTo == `${QualityInspection.STEP_WORK}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_quotationValidate", true);
            patchQualityInspection("_currentStep", QualityInspection.STEP_WORK);
        }

        if (startTo == `${QualityInspection.STEP_PICTURE_AFTER}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_quotationValidate", true);
            patchQualityInspection("_currentStep", QualityInspection.STEP_PICTURE_AFTER);
        }

        if (startTo == `${QualityInspection.STEP_DELIVERY}`) {
            patchIntervention("_appointment", new Date());
            patchQualityInspection("_quotationValidate", true);
            patchQualityInspection("_currentStep", QualityInspection.STEP_DELIVERY);
        }
    }

    const handler = (method, service, entity, property, value, id = null) => {
        if (method === "GET" && service === "service-emergency" && entity === "interventions") {
            return findOneInterventionByToken();
        }

        if (method === "GET" && service === "service-emergency" && entity === "clients") {
            return findOneClientById();
        }

        if (method === "GET" && service === "service-emergency" && entity === "quality_inspections") {
            return findOneQualityInspectionById();
        }

        if (method === "GET" && service === "service-emergency" && entity === "orders") {
            return findOneOrderById();
        }

        if (method === "GET" && service === "service-emergency" && entity === "order_addresses") {
            return findOneOrderAddressById();
        }

        if (method === "GET" && service === "service-emergency" && entity === "order_items") {
            return findAllOrderItems();
        }

        if (method === "GET" && service === "service-emergency" && entity === "requested_documents" && property === "intervention_id") {
            return findAllRequestedDocuments();
        }

        if (method === "GET" && service === "service-emergency" && entity === "requested_documents" && property === "intervention_id") {
            return findOneRequestedDocument(value);
        }

        if (method === "GET" && service === "service-emergency" && entity === "quotations") {
            return findOneQuotationById();
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "quality_inspections" && property === "client_contacted_by_company") {
            return patchQualityInspection("_clientContactedByCompany", true);
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "quality_inspections" && property === "client_not_reply") {
            return patchQualityInspection("_clientNotReply", true);
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "quality_inspections" && property === "current_step") {
            return nextStep(value);
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "requested_documents" && property === "document" && id === 1) {
            patchRequestedDocument(id, "_status", RequestedDocument.STATUS_PROVIDED);
            patchQualityInspection("_currentSubStep", -1);
            patchQualityInspection("_currentStep", QualityInspection.STEP_CLIENT_SIGNATURE);
            return null;
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "requested_documents" && property === "document" && (id === 2 || id === 3)) {
            patchRequestedDocument(id, "_status", RequestedDocument.STATUS_PROVIDED);
            return null;
        }

        if (method === "PATCH" && service === "service-emergency" && entity === "interventions") {
            return true;
        }

        return null;
    }

    const findOneInterventionByToken = () => {
        if (!isNull(intervention)) return;

        const instance = new Intervention({
            second_appointment: null,
            company_id: 1,
            suggestion_id: 1,
            quotation_id: 1,
            client_price: 127.5,
            appointment: null,
            artisan_id: 1,
            token: "demo",
            company_comment: null,
            quality_inspection_id: 1,
            id: 1,
            order_id: 150,
            artisan_price: 165.0,
            status: 0
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "interventions",
            entity: instance
        }));

        return instance;
    }

    const findOneQuotationById = () => {
        if (!isNull(quotation)) return;

        const instance = new Quotation({
            id: 1,
            vat: 10
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "quotations",
            entity: instance
        }));

        return instance;
    }

    const findOneClientById = () => {
        if (!isNull(client)) return;

        const instance = new Client({
            phone_1: "+33600000000",
            name: "Jean Dupont",
            id: 1,
            order_id: 150,
            email: "jean.dupont@mail.com"
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "clients",
            entity: instance
        }));

        return instance;
    }

    const findOneQualityInspectionById = () => {
        if (!isNull(qualityInspection)) return;

        const instance = new QualityInspection({
            current_sub_step: -1,
            intervention_id: 1,
            client_not_reply: false,
            left_at: null,
            quotation_validate: false,
            client_contacted_by_company: false,
            id: 1,
            waiting_prescriber_validation: false,
            arrived_at: null,
            current_step: 0
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "quality_inspections",
            entity: instance
        }));

        return instance;
    }


    const findOneOrderById = () => {
        if (!isNull(order)) return;

        const instance = new Order({
            work_id: 1,
            visio_plus_diagnostic_in_progress: false,
            id: 150,
            visio_plus_diagnostic_id: null,
            prescriber_id: 1
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "orders",
            entity: instance
        }));

        return instance;
    }


    const findOneOrderAddressById = () => {
        if (!isNull(orderAddress)) return;

        const instance = new OrderAddress({
            line_1: "1 avenue de la liberté",
            line_2: null,
            lng: 3.248601,
            city: "Paris",
            postcode: "75000",
            id: 1,
            order_id: 150,
            lat: 43.373033,
            line_3: null
        });

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "order_addresses",
            entity: instance
        }));

        return instance;
    }

    const findOneRequestedDocument = (id) => {
        return requestedDocuments.find(rd => rd?.getId() == id);
    }

    const findAllRequestedDocuments = () => {
        if (!isNull(requestedDocuments)) return;

        const list = [];

        list.push(new RequestedDocument({
            intervention_id: 1,
            name: "Attestation de RAC de 127,50 €",
            id: 1,
            status: 0
        }));

        list.push(new RequestedDocument({
            intervention_id: 1,
            name: RequestedDocument.CLIENT_PRICE_INVOICE_NAME,
            id: 2,
            status: 0
        }));

        list.push(new RequestedDocument({
            intervention_id: 1,
            name: RequestedDocument.DELIVERY_CERTIFICATE_NAME,
            id: 3,
            status: 0
        }));

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "requested_documents",
            entity: list
        }));

        return list;
    }

    const findAllOrderItems = () => {
        if (!isNull(orderItems) && orderItems.length === 2) return;


        const list = [];

        list.push(new OrderItem({
            price: 70.0,
            default_item_id: 11,
            id: 1,
            order_id: 150,
            enabled: true
        }));

        list.push(new OrderItem({
            price: 90.0,
            default_item_id: 12,
            id: 2,
            order_id: 150,
            enabled: true
        }));

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "order_items",
            entity: list
        }));

        return list;
    }

    const patchQualityInspection = (field, value) => {
        qualityInspection[field] = value;

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "quality_inspections",
            entity: qualityInspection
        }));
    }

    const patchIntervention = (field, value) => {
        intervention[field] = value;

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "interventions",
            entity: intervention
        }));
    }

    const patchRequestedDocument = (id, field, value) => {
        requestedDocuments.find(rd => rd.getId() == id)[field] = value;

        dispatch(addOrOverwrite({
            service: "emergency",
            subject: "requested_documents",
            entity: requestedDocuments
        }));
    }

    const nextStep = (value) => {
        if (value.quality_inspection.current_step === QualityInspection.STEP_APPOINTMENT) {
            patchIntervention("_appointment", value.intervention.appointment);
        }

        if (value.quality_inspection.current_step === QualityInspection.STEP_QUOTATION) {
            patchQualityInspection("_currentSubStep", QualityInspection.SUB_STEP_ALL_TO_VALIDATE);

            setTimeout(() => {
                patchQualityInspection("_quotationValidate", true);
                patchQualityInspection("_currentSubStep", QualityInspection.SUB_STEP_ALL_VALIDATED);
            }, QUOTATION_VALIDATION_DELAY);
        }

        patchQualityInspection("_currentStep", value.quality_inspection.current_step);
    }

    const getClientPriceInvoiceDetails = () => {
        return [
            {
                quantity: 1.0,
                price: 57.5,
                name: "Cylindre Opsial 6 goupilles"
            },
            {
                quantity: 1.0,
                price: 70.0,
                name: "Déplacement supplémentaire"
            },
            {
                quantity: 1.0,
                price: 0.0,
                name: "Supplément nuit-weekend ( pris en charge par votre assistance )"
            },
            {
                quantity: 1.0,
                price: 0.0,
                name: "Main d'oeuvre ( pris en charge par votre assistance )"
            },
            {
                quantity: 1.0,
                price: 0.0,
                name: "Déplacement ( pris en charge par votre assistance )"
            }
        ]
    }

    return {
        isLockRequest() {
            return token === "demo";
        },
        handleRequest: handler,
        getClientPriceInvoiceDetails
    }

}